import React from 'react'
import t from 'prop-types'

const IconDownload = ({ width, height }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
      <circle
        className="fill-blue-200 group-hover:fill-blue-100 transition-colors ease-linear duration-200"
        cx="14.5"
        cy="14.5"
        r="14.5"
      />
      <path
        d="M14.5 7a.5.5 0 01.5.5v13.47l5.227-4.112a.5.5 0 01.684.724l-.065.061-6.347 4.994-6.324-4.994a.5.5 0 01.544-.834l.076.05L14 20.967V7.5a.5.5 0 01.5-.5z"
        fill="#FFF"
      />
    </svg>
  )
}

IconDownload.propTypes = {
  width: t.oneOf(t.number, t.string),
  height: t.oneOf(t.number, t.string),
}

IconDownload.defaultProps = {
  width: 29,
  height: 29,
}

export default IconDownload
